import { PartnerAgreementInitialState } from "./model";
import * as types from "./types";

export default function PartnerAgreementReducer(
  state: any = { ...PartnerAgreementInitialState },
  action
) {
  switch (action.type) {
    case types.SET_PARTNER_AGREEMENT.SUCCESS:
      return {
        ...state,
        partnerAgreement: action.payload,
        isProcessing: false,
      };
    case types.SET_COMMITMENT.SUCCESS:
      return {
        ...state,
        commitment: action.payload,
      };
    case types.SET_PARTNER_AGREEMENT.ERROR:
      return {
        ...state,
        error: {
          ...state,
          errorCode: action.payload && action.payload.code,
          errorMessage: action.payload
            ? action.payload.additional_errors[0]
            : "An unknown error has occurred!",
        },
      };

    case types.SET_PARTNER_AGREEMENT.PENDING:
      return {
        ...state,
        isProcessing: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/reducer.js